import React from "react";
import { LiveStreamBox } from "..";
import "../../../assets/css/liveBox.css";

const LiveBox = (props) => {
  return (
    <>
      <div className="live-box yu-gothic center">
        <LiveStreamBox youtubeApiKey={props.youtubeApiKey} youtubeChannelId={props.youtubeChannelId} />
      </div>
    </>
  );
};

export default LiveBox;
